<script>
    import {analyticsTrackCTA} from "../../analitics/analytics";
    import ContactsForm from "./ContactsForm.svelte";
    import {timer} from '../../helpers/timer';
    import axios from 'axios';

    export let Text;
    export let TextForm;
    export let subText;
    export let sendText;
    export let greetingText;
    export let greetingSubText;
    export let form;
    export let loadingText;
    export let formIncopleteText;
    export let phoneText;
    let sended = false;
    let loading = false;
    let valid = false;

    let validation = (() => {

        let obj = {};
        if (form != null)
            form.forEach((field) => {
                let key = field.name;
                obj[key] = (value) => {
                    return value != null;
                }
            });
        return obj;
    })();

    let api = 'https://europe-west2-lobesoftwebsite.cloudfunctions.net/websiteApi';

    let formValue;
    $: {
        valid = validate(validation, formValue);
        //console.log(validate(validation,formValue));
    }
    let onWorkTime = false;

    if (timer([9, 21])) {
        onWorkTime = true;
    }

    function onClick(name) {
        analyticsTrackCTA(name, '');
    }

    function onSend() {

        if (valid !== true) {
            console.log('error');
            return;
        }

        if (loading) {
            return;
        }

        loading = true;
        console.log('SENDING');
        analyticsTrackCTA('form', '');
        axios.post(api + '/siteContacts', formValue, {headers: {Authorization: '7867298340947'}}).then((res) => {
            console.log(res);
            loading = false;
            sended = true;
        }).catch((e) => {
            console.log(e);
            loading = false;
        });
    }

    function onCall(event) {
        let node = event.target;
        let toki;
        document.querySelectorAll('iframe').forEach(item =>
                toki = item.contentWindow.document.querySelector('a[id="show-call"]')
        );
        console.log('toki', toki);
        if (toki) {
            toki.click();
            let popUp;
            popUp = document.querySelector('iframe[title="Widget Modal"]');

            console.log('popup', popUp);
            if (popUp) {
                setTimeout(() => {
                    let btn = popUp.contentWindow.document.querySelector('button[id="callButton"]');
                    let close = popUp.contentWindow.document.querySelector('a[class="toky-close"]');
                    btn.click();
                    close.click();
                }, 500);

                popUp.style.display = 'none';
                //popUp.style.position = 'absolute';
                /*popUp.style.top = node.getBoundingClientRect().top + window.scrollY - popUp.getBoundingClientRect().height +'px';
                popUp.style.left = node.getBoundingClientRect().left - (popUp.getBoundingClientRect().width / 2) + (node.getBoundingClientRect().width / 2) + 'px';*/
            }
        }
    }

    /* obj with validadion for each field, value */
    function validate(rule, value) {
        if (!value) {
            return false;
        }
        for (let ruleK in rule) {
            let check = rule[ruleK];
            let currentValue = value[ruleK];

            //console.log(check(currentValue),currentValue,ruleK);

            if (!value.hasOwnProperty(ruleK)) {
                return false;
            }

            if (!check(currentValue)) {
                return ruleK;
            }
        }
        return true;
    }

</script>

<style>
    .invalid {
        background-color: #d2d2d2;
        opacity: 0.5;
        pointer-events: none;
    }
</style>

<component editor-editable="true">
    <style>
        .disabled {
            opacity: 0.6;
        }

        .sending {

        }

        .C8396ce14-304e-ea92-406d-956d73d7f883 DIV.col-lg-4 {
            color: #484848;
            font-family: poppins, sans-serif;
            font-size: 1em;
            line-height: 1.65714286em;
            position: relative;
            text-align: left;
            -webkit-font-smoothing: antialiased;
            -webkit-tap-highlight-color: transparent;
        }

        .C8396ce14-304e-ea92-406d-956d73d7f883 * {
            box-sizing: border-box;
        }

        .C8396ce14-304e-ea92-406d-956d73d7f883 ::after {
            box-sizing: border-box;
        }

        .C8396ce14-304e-ea92-406d-956d73d7f883 ::before {
            box-sizing: border-box;
        }

        .C8396ce14-304e-ea92-406d-956d73d7f883 h3 {
            margin-top: 0;
            margin-bottom: .5rem;
        }

        .C8396ce14-304e-ea92-406d-956d73d7f883 p {
            margin-top: 0;
            margin-bottom: 1rem;
        }

        .C8396ce14-304e-ea92-406d-956d73d7f883 a {
            z color: #ff0229;
            text-decoration: none;
            background-color: transparent;
        }

        .C8396ce14-304e-ea92-406d-956d73d7f883 a:hover {
            color: #b30107;
            text-decoration: underline;
        }

        .C8396ce14-304e-ea92-406d-956d73d7f883 a:not([href]):not([tabindex]) {
            color: inherit;
            text-decoration: none;
        }

        .C8396ce14-304e-ea92-406d-956d73d7f883 a:not([href]):not([tabindex]):focus {
            color: inherit;
            text-decoration: none;
        }

        .C8396ce14-304e-ea92-406d-956d73d7f883 a:not([href]):not([tabindex]):hover {
            color: inherit;
            text-decoration: none;
        }

        .C8396ce14-304e-ea92-406d-956d73d7f883 a:not([href]):not([tabindex]):focus {
            outline: 0;
        }

        .C8396ce14-304e-ea92-406d-956d73d7f883 h3 {
            margin-bottom: .5rem;
            font-weight: 500;
            line-height: 1.2;
        }

        .C8396ce14-304e-ea92-406d-956d73d7f883 h3 {
            font-size: 1.75rem;
        }

        .C8396ce14-304e-ea92-406d-956d73d7f883 .col-lg-4 {
            position: relative;
            width: 100%;
            padding-right: 15px;
            padding-left: 15px;
        }

        @media (min-width: 992px) {
            .C8396ce14-304e-ea92-406d-956d73d7f883 .col-lg-4 {
                -ms-flex: 0 0 33.333333%;
                flex: 0 0 33.333333%;
                max-width: 33.333333%;
            }
        }

        .C8396ce14-304e-ea92-406d-956d73d7f883 .btn {
            display: inline-block;
            font-weight: 400;
            font-size: 1.3em;
            color: #212529;
            text-align: center;
            vertical-align: middle;
            -webkit-user-select: none;
            -moz-user-select: none;
            -ms-user-select: none;
            user-select: none;
            background-color: transparent;
            border: 1px solid transparent;
            padding: .375rem .75rem;
            line-height: 1.5;
            border-radius: .25rem;
            transition: color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;
        }

        @media (prefers-reduced-motion: reduce) {
            .C8396ce14-304e-ea92-406d-956d73d7f883 .btn {
                transition: none;
            }
        }

        .C8396ce14-304e-ea92-406d-956d73d7f883 .btn:hover {
            color: #212529;
            text-decoration: none;
        }

        .C8396ce14-304e-ea92-406d-956d73d7f883 .btn:focus {
            outline: 0;
            box-shadow: 0 0 0 .2rem rgba(0, 123, 255, .25);
        }

        .C8396ce14-304e-ea92-406d-956d73d7f883 .btn:disabled {
            opacity: .65;
        }

        .C8396ce14-304e-ea92-406d-956d73d7f883 .btn-light {
            color: #212529;
            background-color: #f8f9fa;
            border-color: #f8f9fa;
        }

        .C8396ce14-304e-ea92-406d-956d73d7f883 .btn-light:hover {
            color: #212529;
            background-color: #e2e6ea;
            border-color: #dae0e5;
        }

        .C8396ce14-304e-ea92-406d-956d73d7f883 .btn-light:focus {
            box-shadow: 0 0 0 .2rem rgba(216, 217, 219, .5);
        }

        .C8396ce14-304e-ea92-406d-956d73d7f883 .btn-light:disabled {
            color: #212529;
            background-color: #f8f9fa;
            border-color: #f8f9fa;
        }

        @media print {
            .C8396ce14-304e-ea92-406d-956d73d7f883 * {
                text-shadow: none !important;
                box-shadow: none !important;
            }

            .C8396ce14-304e-ea92-406d-956d73d7f883 ::after {
                text-shadow: none !important;
                box-shadow: none !important;
            }

            .C8396ce14-304e-ea92-406d-956d73d7f883 ::before {
                text-shadow: none !important;
                box-shadow: none !important;
            }

            .C8396ce14-304e-ea92-406d-956d73d7f883 h3 {
                orphans: 3;
                widows: 3;
            }

            .C8396ce14-304e-ea92-406d-956d73d7f883 p {
                orphans: 3;
                widows: 3;
            }

            .C8396ce14-304e-ea92-406d-956d73d7f883 h3 {
                page-break-after: avoid;
            }
        }

        /*! CSS Used from: http://inspirothemes.com/polo-v5.8/css/style.css*/
        .C8396ce14-304e-ea92-406d-956d73d7f883 * {
            padding: 0;
            text-decoration: none;
        }

        .C8396ce14-304e-ea92-406d-956d73d7f883 h3 {
            margin: 0;
            padding: 0;
            text-decoration: none;
        }

        .C8396ce14-304e-ea92-406d-956d73d7f883 a {
            margin: 0;
            padding: 0;
            text-decoration: none;
        }

        .C8396ce14-304e-ea92-406d-956d73d7f883 h3 {
            font-family: poppins, sans-serif;
            color: #1f1f1f;
            margin: 0;
            letter-spacing: .5px;
        }

        .C8396ce14-304e-ea92-406d-956d73d7f883 h3 {
            font-size: 1.78571429em;
            line-height: 1.5em;
            font-weight: 500;
        }

        .C8396ce14-304e-ea92-406d-956d73d7f883 h3:not(:last-child) {
            margin-bottom: 12px;
        }

        @media all and (max-width: 767px) {
            .C8396ce14-304e-ea92-406d-956d73d7f883 h3 {
                font-size: 1.35714286em;
                line-height: 1.85714286em;
            }
        }

        .C8396ce14-304e-ea92-406d-956d73d7f883 p {
            font-size: 1rem;
            font-style: normal;
            font-weight: 400;
            text-transform: none;
            line-height: 1.7;
            letter-spacing: 0;
            color: #777;
            font-family: poppins, sans-serif;
        }

        .C8396ce14-304e-ea92-406d-956d73d7f883 .btn:not(.close):not(.mfp-close) {
            font-family: poppins, sans-serif;
            border-radius: 5px 5px 5px 5px;
            font-size: 1em;
            font-weight: 600;
            letter-spacing: .5px;
            text-decoration: none;
            outline: none;
            padding: 12px 18px;
            position: relative;
            background-color: #2250fc;
            border-color: #2250fc;
            border-width: 1px;
            border-style: solid;
            color: #fff;
            -webkit-transition: all .3s;
            transition: all .3s;
            margin-bottom: 6px;
            outline: none;
            line-height: 14px;
            cursor: pointer;
        }

        .C8396ce14-304e-ea92-406d-956d73d7f883 a.btn:not([href]):not([tabindex]) {
            font-family: poppins, sans-serif;
            border-radius: 5px 5px 5px 5px;
            font-size: 2em;
            font-weight: 600;
            letter-spacing: .5px;
            text-decoration: none;
            outline: none;
            padding: 12px 18px;
            position: relative;
            text-transform: uppercase;
            background-color: #2250fc;
            border-color: #2250fc;
            border-width: 1px;
            border-style: solid;
            color: #fff;
            -webkit-transition: all .3s;
            transition: all .3s;
            margin-bottom: 6px;
            outline: none;
            line-height: 14px;
            cursor: pointer;
        }

        .C8396ce14-304e-ea92-406d-956d73d7f883 .btn:not(.close):not(.mfp-close):after {
            content: '';
            position: absolute;
            z-index: -1;
            -webkit-transition: all .3s;
            transition: all .3s;
        }

        .C8396ce14-304e-ea92-406d-956d73d7f883 a.btn:not([href]):not([tabindex]):after {
            content: '';
            position: absolute;
            z-index: -1;
            -webkit-transition: all .3s;
            transition: all .3s;
        }

        .C8396ce14-304e-ea92-406d-956d73d7f883 .btn:not(.close):not(.mfp-close):hover {
            background-color: #0333e8;
            border-color: #0333e8;
            color: #fff;
            text-decoration: none;
        }

        .C8396ce14-304e-ea92-406d-956d73d7f883 .btn:not(.close):not(.mfp-close):focus {
            background-color: #0333e8;
            border-color: #0333e8;
            color: #fff;
            text-decoration: none;
        }

        .C8396ce14-304e-ea92-406d-956d73d7f883 a.btn:not([href]):not([tabindex]):hover {
            background-color: #0333e8;
            border-color: #0333e8;
            color: #fff;
            text-decoration: none;
        }

        .C8396ce14-304e-ea92-406d-956d73d7f883 a.btn:not([href]):not([tabindex]):focus {
            background-color: #0333e8;
            border-color: #0333e8;
            color: #fff;
            text-decoration: none;
        }

        .C8396ce14-304e-ea92-406d-956d73d7f883 .btn:not(.close):not(.mfp-close).btn-outline {
            background-color: transparent;
            border-width: 2px;
            border-style: solid;
            border-color: #2250fc;
            color: #2250fc;
        }

        .C8396ce14-304e-ea92-406d-956d73d7f883 a.btn:not([href]):not([tabindex]).btn-outline {
            background-color: transparent;
            border-width: 2px;
            border-style: solid;
            border-color: #2250fc;
            color: #2250fc;
        }

        .C8396ce14-304e-ea92-406d-956d73d7f883 .btn:not(.close):not(.mfp-close).btn-outline:hover {
            background-color: #2250fc;
            border-width: 2px;
            border-style: solid;
            border-color: #2250fc;
            color: #fff;
        }

        .C8396ce14-304e-ea92-406d-956d73d7f883 .btn:not(.close):not(.mfp-close).btn-outline:focus {
            background-color: #2250fc;
            border-width: 2px;
            border-style: solid;
            border-color: #2250fc;
            color: #fff;
        }

        .C8396ce14-304e-ea92-406d-956d73d7f883 .btn:not(.close):not(.mfp-close).btn-outline:active {
            background-color: #2250fc;
            border-width: 2px;
            border-style: solid;
            border-color: #2250fc;
            color: #fff;
        }

        .C8396ce14-304e-ea92-406d-956d73d7f883 a.btn:not([href]):not([tabindex]).btn-outline:hover {
            background-color: #2250fc;
            border-width: 2px;
            border-style: solid;
            border-color: #2250fc;
            color: #fff;
        }

        .C8396ce14-304e-ea92-406d-956d73d7f883 a.btn:not([href]):not([tabindex]).btn-outline:focus {
            background-color: #2250fc;
            border-width: 2px;
            border-style: solid;
            border-color: #2250fc;
            color: #fff;
        }

        .C8396ce14-304e-ea92-406d-956d73d7f883 a.btn:not([href]):not([tabindex]).btn-outline:active {
            background-color: #2250fc;
            border-width: 2px;
            border-style: solid;
            border-color: #2250fc;
            color: #fff;
        }

        .C8396ce14-304e-ea92-406d-956d73d7f883 .btn:not(.close):not(.mfp-close).btn-light {
            background-color: #fff;
            border-color: #ebebeb;
            color: #4c5667;
        }

        .C8396ce14-304e-ea92-406d-956d73d7f883 a.btn:not([href]):not([tabindex]).btn-light {
            background-color: #fff;
            border-color: #ebebeb;
            color: #4c5667;
        }

        .C8396ce14-304e-ea92-406d-956d73d7f883 .btn:not(.close):not(.mfp-close).btn-light:hover {
            border-color: #ebedf2;
            background-color: #f4f5f8;
            color: #4c5667;
        }

        .C8396ce14-304e-ea92-406d-956d73d7f883 .btn:not(.close):not(.mfp-close).btn-light:focus {
            border-color: #ebedf2;
            background-color: #f4f5f8;
            color: #4c5667;
        }

        .C8396ce14-304e-ea92-406d-956d73d7f883 .btn:not(.close):not(.mfp-close).btn-light:active {
            border-color: #ebedf2;
            background-color: #f4f5f8;
            color: #4c5667;
        }

        .C8396ce14-304e-ea92-406d-956d73d7f883 a.btn:not([href]):not([tabindex]).btn-light:hover {
            border-color: blue;
            background-color: #f4f5f8;
            color: #4c5667;
        }

        .C8396ce14-304e-ea92-406d-956d73d7f883 a.btn:not([href]):not([tabindex]).btn-light:focus {
            border-color: #ebedf2;
            background-color: #f4f5f8;
            color: #4c5667;
        }

        .C8396ce14-304e-ea92-406d-956d73d7f883 a.btn:not([href]):not([tabindex]).btn-light:active {
            border-color: #ebedf2;
            background-color: #f4f5f8;
            color: #4c5667;
        }

        .C8396ce14-304e-ea92-406d-956d73d7f883 .btn:not(.close):not(.mfp-close).btn-light.btn-outline {
            border-color: #fff;
            background-color: transparent;
            color: #fff;
        }

        .C8396ce14-304e-ea92-406d-956d73d7f883 a.btn:not([href]):not([tabindex]).btn-light.btn-outline {
            border-color: #fff;
            background-color: transparent;
            color: #fff;
        }

        .C8396ce14-304e-ea92-406d-956d73d7f883 .btn:not(.close):not(.mfp-close).btn-light.btn-outline:hover {
            background-color: #fff;
            color: #4c5667;
        }

        .C8396ce14-304e-ea92-406d-956d73d7f883 .btn:not(.close):not(.mfp-close).btn-light.btn-outline:focus {
            background-color: #fff;
            color: #4c5667;
        }

        .C8396ce14-304e-ea92-406d-956d73d7f883 .btn:not(.close):not(.mfp-close).btn-light.btn-outline:active {
            background-color: #fff;
            color: #4c5667;
        }

        .C8396ce14-304e-ea92-406d-956d73d7f883 a.btn:not([href]):not([tabindex]).btn-light.btn-outline:hover {
            background-color: #fff;
            color: #4c5667;
        }

        .C8396ce14-304e-ea92-406d-956d73d7f883 a.btn:not([href]):not([tabindex]).btn-light.btn-outline:focus {
            background-color: #fff;
            color: #4c5667;
        }

        .C8396ce14-304e-ea92-406d-956d73d7f883 a.btn:not([href]):not([tabindex]).btn-light.btn-outline:active {
            background-color: #fff;
            color: #4c5667;
        }

        .C8396ce14-304e-ea92-406d-956d73d7f883 .btn:not(.close):not(.mfp-close):not(.btn-shadow):focus {
            -webkit-box-shadow: none !important;
            box-shadow: none !important;
        }

        .C8396ce14-304e-ea92-406d-956d73d7f883 .btn:not(.close):not(.mfp-close):not(.btn-shadow):focus:active {
            -webkit-box-shadow: none !important;
            box-shadow: none !important;
        }

        .C8396ce14-304e-ea92-406d-956d73d7f883 a.btn:not([href]):not([tabindex]):not(.btn-shadow):focus {
            -webkit-box-shadow: none !important;
            box-shadow: none !important;
        }

        .C8396ce14-304e-ea92-406d-956d73d7f883 a.btn:not([href]):not([tabindex]):not(.btn-shadow):focus:active {
            -webkit-box-shadow: none !important;
            box-shadow: none !important;
        }

        .C8396ce14-304e-ea92-406d-956d73d7f883 .call-to-action {
            position: relative;
            overflow: hidden;
            padding: 46px 50px 34px;
            margin-bottom: 40px;
        }

        .C8396ce14-304e-ea92-406d-956d73d7f883 .call-to-action h3 {
            margin-top: 10px;
            font-weight: 600;
            margin-bottom: 10px;
        }

        .C8396ce14-304e-ea92-406d-956d73d7f883 .call-to-action p {
            margin-top: 0;
        }

        .C8396ce14-304e-ea92-406d-956d73d7f883 .call-to-action a.btn {
            margin-top: 20px;
        }

        .C8396ce14-304e-ea92-406d-956d73d7f883 .call-to-action.call-to-action-colored {
            margin: 0;
            background-color: #fc082b;
            background-image: url("https://storage.googleapis.com/cms.lobesoft.com/2019/12/be1b21ee-bg-scaled.jpg");
            background-size: auto;
            background-repeat: repeat;
            background-blend-mode: multiply;
        }

        .C8396ce14-304e-ea92-406d-956d73d7f883 .call-to-action.call-to-action-colored h3 {
            color: #fff;
        }

        .C8396ce14-304e-ea92-406d-956d73d7f883 .call-to-action.call-to-action-colored p {
            color: #fff;
        }

        .C8396ce14-304e-ea92-406d-956d73d7f883 .call-to-action.call-to-action-colored label {
            color: #fff;
        }

        .C8396ce14-304e-ea92-406d-956d73d7f883 .call-to-action.call-to-action-colored h3 span {
            color: #fff !important;
        }

        @media (max-width: 991px) {
            .C8396ce14-304e-ea92-406d-956d73d7f883 .call-to-action {
                padding: 26px 12px 18px;
            }

            .C8396ce14-304e-ea92-406d-956d73d7f883 [class*=col-] > .call-to-action {
                padding: 26px 26px 18px;
            }
        }
    </style>
    <div class="C8396ce14-304e-ea92-406d-956d73d7f883" editor-layout="true">
        <div class="col-lg-12" style="text-align: center">
            <div class="row align-items-center call-to-action call-to-action-colored">
                <div class="col-md-12 col-lg-5 offset-0 offset-lg-1">
                    <h3>
                        {@html Text}
                    </h3>
                    <p>
                        {@html subText}
                    </p>
                    <a class="btn col-12 col-sm-auto btn-light d-md-none" href="https://wa.me/+17864530818"
                       on:click={()=>{onClick('whatsapp') }}><i class="fab fa-whatsapp"></i> Whatsapp</a>
                    <a class="btn col-12 col-sm-auto btn-light d-none d-md-inline-flex shadow-drop-bl-hover"
                       target="_blank" href="https://web.whatsapp.com/send?phone=+17864530818"
                       on:click={()=>{ onClick('whatsapp') }}><i class="fab fa-whatsapp"></i> Whatsapp</a>
                    <a class="btn col-12 col-sm-auto  btn-light shadow-drop-bl-hover" href="mailto:info@lobesoft.com"
                       on:click={()=>{ onClick('email') }}><i class="far fa-envelope"></i> info@lobesoft.com</a>
                    {#if onWorkTime}
                        <a class="btn col-12 col-sm-auto btn-light shadow-drop-bl-hover"
                           href="https://app.toky.co/lobesoftllc" target="_blank"
                           on:click={(event)=>{onClick('phone') }}><i class="far fa-phone"></i>
                            {phoneText}</a>
                    {/if}
                </div>
                <div class="col-md-12 col-lg-5">
                    {#if !sended}
                        <div class="d-none d-md-block">
                            <h3>
                                {@html TextForm}
                            </h3>
                            <div class="container-fluid">
                                <div class="col-12 col-md-6 offset-md-3 col-lg-8 offset-lg-2">
                                    <ContactsForm bind:value={formValue} fields={form}/>
                                </div>
                            </div>
                            <a on:click={() =>{onSend(); onClick('message')}}
                               class="btn col-12 col-sm-auto {valid !== true ? 'invalid' : ''}  btn-light shadow-drop-bl-hover"
                               href=""><i class="fal fa-paper-plane"></i>
                                {@html  loading ? loadingText : valid === true ? sendText : formIncopleteText}</a>
                        </div>
                    {/if}
                    {#if sended}
                        <div style="padding: 6em">
                            <h3>
                                {@html greetingText}
                            </h3>
                            <p>
                                {@html greetingSubText}
                            </p>
                        </div>
                    {/if}
                </div>
            </div>

        </div>
    </div>
</component>
